import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { RootState } from '../index';

export type PlayerAchievements = {
  achievements?: any[];
  categories?: any[];
};

interface PlayerAchievementsState {
  data: PlayerAchievements | null;
  loading: boolean;
  error: string | null;
  lastFetched: string | null;
}

const initialState: PlayerAchievementsState = {
  data: null,
  loading: false,
  error: null,
  lastFetched: null
};

const apiUrl = window.config.playerApiUrl;

export const fetchPlayerAchievements = createAsyncThunk(
  'playerAchievements/fetchPlayerAchievements',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state: RootState = getState() as RootState;

      if (state.authentication.access_token && state.authentication.auth_type === 'user') {
        const response = await axios.get<PlayerAchievements>(`${apiUrl}/player/data/player-achievements`, {
          headers: {
            Authorization: 'Bearer ' + state.authentication.access_token,
          },
        });

        if (response.data) {
          return { data: response.data, success: true };
        }
      }
      return rejectWithValue({
        error: 'Failed to fetch player achievements',
      });
    } catch (err: any) {
      // until we have BE this is mocked
      return {
        data: {
          hall_of_fame: {
            selectedBadges: [
              { id: '1', image: 'badge1.png', name: { en: 'Badge 1', ro: 'Badge 1', pt: 'Badge 1' } },
              { id: '2', image: 'badge2.png', name: { en: 'Badge 2', ro: 'Badge 2', pt: 'Badge 2' } },
              { id: '3', image: 'badge3.png', name: { en: 'Badge 3', ro: 'Badge 3', pt: 'Badge 3' } },
            ],
            badges: [
              { id: '4', image: 'badge4.png', name: { en: 'Badge 4', ro: 'Badge 4', pt: 'Badge 4' } },
              { id: '5', image: 'badge5.png', name: { en: 'Badge 5', ro: 'Badge 5', pt: 'Badge 5' } },
            ],
          },
          categories: [
            {
              name: 'SLOTS',
            },
            {
              name: 'SPORT',
            }
          ],
          achievements: [
            {
              'id': '1',
              'code': 'string',
              'name': 'Plinko/Hilo Master',
              'description': 'Master Plinko and HiLo games through extensive play',
              'iconUrl': '/assets/achievements/plinko_hilo_master.png',
              'category': 'SLOTS',
              'subcategory': 'ORIGINALS',
              'vertical': 'CASINO',
              'displayOrder': 1,
              'currentLevel': 1,
              'maxLevel': 0,
              'isActive': true,
              'levels': [
                {
                  'level': 1,
                  'requirementLabel': 'Bet at least 10 times in Plinko/HiLo',
                  'isLocked': false,
                  'isCompleted': false,
                  'completedAt': '2025-05-13T14:54:19.899Z',
                  'rewardId': 1,
                  'rewardName': '6 Free Spins',
                  'rewardUrl': 'api/rewards/2001',
                  'rewardClaimed': false,
                  'requirementType': 'COUNT',
                  'progress': 0,
                  'requiredCount': 10,
                  'progressPercentage': 0,
                  'requirementDetails': {
                    'betsPerGame': 0,
                    'gamesPlayed': [
                      {
                        'gameId': '2148',
                        'name': 'Plinko',
                        'bets': 3,
                        'qualified': true,
                        'required': 0
                      }
                    ]
                  }
                }
              ]
            },
            {
              'id': '2',
              'code': 'string',
              'name': 'Plinko/Hilo Master',
              'description': 'Master Plinko and HiLo games through extensive play',
              'iconUrl': '/assets/achievements/plinko_hilo_master.png',
              'category': 'SLOTS',
              'subcategory': 'ORIGINALS',
              'vertical': 'CASINO',
              'displayOrder': 1,
              'currentLevel': 1,
              'maxLevel': 0,
              'isActive': true,
              'levels': [
                {
                  'level': 1,
                  'requirementLabel': 'Bet at least 50 times in Plinko/HiLo',
                  'isLocked': false,
                  'isCompleted': false,
                  'completedAt': '2025-05-13T14:54:19.899Z',
                  'rewardId': 1,
                  'rewardName': '6 Free Spins',
                  'rewardUrl': 'api/rewards/2001',
                  'rewardClaimed': false,
                  'requirementType': 'COUNT',
                  'progress': 7,
                  'requiredCount': 10,
                  'progressPercentage': 70,
                  'requirementDetails': {
                    'betsPerGame': 0,
                    'gamesPlayed': [
                      {
                        'gameId': '2148',
                        'name': 'Plinko',
                        'bets': 3,
                        'qualified': true,
                        'required': 0
                      }
                    ]
                  }
                }
              ]
            },
            {
              'id': '3',
              'code': 'string',
              'name': 'Plinko/Hilo Master',
              'description': 'Master Plinko and HiLo games through extensive play',
              'iconUrl': '/assets/achievements/plinko_hilo_master.png',
              'category': 'SLOTS',
              'subcategory': 'ORIGINALS',
              'vertical': 'CASINO',
              'displayOrder': 1,
              'currentLevel': 1,
              'maxLevel': 0,
              'isActive': true,
              'levels': [
                {
                  'level': 1,
                  'requirementLabel': 'Bet at least 50 times in Plinko/HiLo',
                  'isLocked': false,
                  'isCompleted': true,
                  'completedAt': '2025-05-13T14:54:19.899Z',
                  'rewardId': 1,
                  'rewardName': '6 Free Spins',
                  'rewardUrl': 'api/rewards/2001',
                  'rewardClaimed': false,
                  'requirementType': 'COUNT',
                  'progress': 10,
                  'requiredCount': 10,
                  'progressPercentage': 100,
                  'requirementDetails': {
                    'betsPerGame': 0,
                    'gamesPlayed': [
                      {
                        'gameId': '2148',
                        'name': 'Plinko',
                        'bets': 3,
                        'qualified': true,
                        'required': 0
                      }
                    ]
                  }
                }
              ]
            },
            {
              'id': '3  ',
              'code': 'string',
              'name': 'Slot Explorer',
              'description': 'Explore a variety of slot games',
              'iconUrl': '/assets/achievements/plinko_hilo_master.png',
              'category': 'SLOTS',
              'subcategory': 'ORIGINALS',
              'vertical': 'CASINO',
              'displayOrder': 1,
              'currentLevel': 2,
              'maxLevel': 0,
              'isActive': true,
              'levels': [
                {
                  'level': 1,
                  'requirementLabel': 'Play 10 different slot games',
                  'isLocked': false,
                  'isCompleted': true,
                  'completedAt': '2025-05-13T14:54:19.899Z',
                  'rewardId': 1,
                  'rewardName': '6 Free Spins',
                  'rewardUrl': 'api/rewards/2001',
                  'rewardClaimed': true,
                  'requirementType': 'COUNT',
                  'progress': 10,
                  'requiredCount': 10,
                  'progressPercentage': 100,
                  'requirementDetails': {
                    'betsPerGame': 0,
                    'gamesPlayed': [
                      {
                        'gameId': '2148',
                        'name': 'Plinko',
                        'bets': 3,
                        'qualified': true,
                        'required': 0
                      }
                    ]
                  }
                },
                {
                  'level': 2,
                  'requirementLabel': 'Play 25 different slot gamesxxxx',
                  'isLocked': false,
                  'isCompleted': false,
                  'completedAt': '2025-05-13T14:54:19.899Z',
                  'rewardId': 1,
                  'rewardName': '16 Free Spins',
                  'rewardUrl': 'api/rewards/2001',
                  'rewardClaimed': false,
                  'requirementType': 'COUNT',
                  'progress': 7,
                  'requiredCount': 10,
                  'progressPercentage': 70,
                  'requirementDetails': {
                    'betsPerGame': 0,
                    'gamesPlayed': [
                      {
                        'gameId': '2148',
                        'name': 'Plinko',
                        'bets': 3,
                        'qualified': true,
                        'required': 0
                      }
                    ]
                  }
                },
                {
                  'level': 3,
                  'requirementLabel': 'Play 35 different slot games',
                  'isLocked': true,
                  'isCompleted': false,
                  'completedAt': '2025-05-13T14:54:19.899Z',
                  'rewardId': 1,
                  'rewardName': '26 Free Spins',
                  'rewardUrl': 'api/rewards/2001',
                  'rewardClaimed': false,
                  'requirementType': 'COUNT',
                  'progress': 0,
                  'requiredCount': 10,
                  'progressPercentage': 0,
                  'requirementDetails': {
                    'betsPerGame': 0,
                    'gamesPlayed': [
                      {
                        'gameId': '2148',
                        'name': 'Plinko',
                        'bets': 3,
                        'qualified': true,
                        'required': 0
                      }
                    ]
                  }
                },
              ]
            },
          ],
        },
        success: true,
      };
      const errResp = { error: err.toString() };
      return rejectWithValue(errResp);
    }
  }
);

const playerAchievementsSlice = createSlice({
  name: 'playerAchievements',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlayerAchievements.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPlayerAchievements.fulfilled, (state, action: PayloadAction<{ data: PlayerAchievements; success: boolean; }>) => {
        state.loading = false;
        state.data = action.payload.data;

        state.lastFetched = new Date().toISOString();
      })
      .addCase(fetchPlayerAchievements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string || 'Unknown error occurred';
      });
  }
});


// Export selectors
export const selectPlayerAchievements = (state: { playerAchievements: PlayerAchievementsState; }) => state.playerAchievements.data;
export const selectPlayerAchievementsLoading = (state: { playerAchievements: PlayerAchievementsState; }) => state.playerAchievements.loading;
export const selectPlayerAchievementsError = (state: { playerAchievements: PlayerAchievementsState; }) => state.playerAchievements.error;
export const selectLastFetched = (state: { playerAchievements: PlayerAchievementsState; }) => state.playerAchievements.lastFetched;

export default playerAchievementsSlice.reducer;
